import { Component } from '@angular/core';
import { MENU_PAGE } from 'src/app/shared/defines/desktop.const';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent {
  protected readonly MENU_PAGE = MENU_PAGE;

}
